// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"522":"26d6f5a6","553":"b5229c96"}[chunkId] + ".chunk.js";
};